var map = {
	"./de_1.jpg": "ff01",
	"./de_2.jpg": "fbbc",
	"./de_3.jpg": "0668",
	"./en_1.jpg": "84da",
	"./en_2.jpg": "57be",
	"./en_3.jpg": "3352",
	"./it_1.jpg": "0cb1",
	"./it_2.jpg": "f0f7",
	"./it_3.jpg": "b887",
	"./sl_1.jpg": "0934",
	"./sl_2.jpg": "fa05",
	"./sl_3.jpg": "f9e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b78e";